export default __webpack_public_path__ + "static/media/home1.8659b146.jpg";